import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";

export default function AuthLayout() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      }
      return null;
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <div className="relative h-screen w-full overflow-hidden bg-black">
      <main className="h-full w-full">
        <Routes>
          {getRoutes(routes)}
          <Route
            path="/"
            element={<Navigate to="/auth/sign-in" replace />}
          />
        </Routes>
      </main>
    </div>
  );
}